const JSLogo = ({ width = 75, height = 75 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.25 6.94238H93.75V94.4424H6.25V6.94238Z"
          fill="#F5DE19"
        />
        <path
          d="M65.0277 75.3017C65.7744 76.8152 66.933 78.0872 68.3703 78.9717C69.8075 79.8561 71.4652 80.3172 73.1527 80.3017C76.559 80.3017 78.7371 78.5986 78.7371 76.2392C78.7371 73.4267 76.4996 72.4205 72.7496 70.7799L70.6934 69.8986C64.7559 67.3705 60.8184 64.2049 60.8184 57.5111C60.8184 51.3455 65.5059 46.6486 72.859 46.6486C75.2392 46.4771 77.6173 47.0101 79.6968 48.1809C81.7762 49.3518 83.4651 51.1088 84.5527 53.233L78.1246 57.3424C77.7055 56.2893 76.9765 55.3883 76.0339 54.7588C75.0913 54.1293 73.9798 53.801 72.8465 53.8174C72.352 53.7679 71.8526 53.8219 71.3801 53.9761C70.9077 54.1302 70.4725 54.3811 70.1024 54.7127C69.7323 55.0444 69.4352 55.4495 69.2303 55.9022C69.0254 56.3549 68.917 56.8454 68.9121 57.3424C68.9121 59.808 70.4402 60.808 73.9684 62.3424L76.0246 63.2236C83.0121 66.2205 86.9621 69.2736 86.9621 76.1392C86.9621 83.5424 81.1465 87.5986 73.3371 87.5986C70.2946 87.7905 67.2615 87.0988 64.603 85.6069C61.9445 84.1149 59.774 81.8862 58.3527 79.1892L65.0277 75.3017ZM35.9809 76.0142C37.2715 78.3049 38.4465 80.2424 41.2715 80.2424C43.9715 80.2424 45.6777 79.1861 45.6777 75.0767V47.1174H53.8996V75.1861C53.8996 83.6986 48.8996 87.5736 41.6215 87.5736C39.0488 87.7142 36.4938 87.0731 34.2924 85.7345C32.0909 84.3959 30.346 82.4224 29.2871 80.0736L35.9809 76.0142Z"
          fill="black"
        />
      </svg>
    );
  };
  
  export default JSLogo;
  